var topTitleMenu = {
  init: function init() {
    var showAllOption = $('#showAllApplications');
    var filterComponent = $('#filterComponent').find('[data-pimid="ModelApplication"]');
    var listOfSiblings = filterComponent.siblings('div');
    var labelDestination = $('#topTitleComponent').find('.topTitleComponent-shopByLinks');
    var labels = [];

    //Move labels from original render area
    for (var i = 0; i < listOfSiblings.length; i++) {
      if (!$(listOfSiblings[i]).hasClass("filterComponent-nomatch")) {
        var label = $(listOfSiblings[i]).find('label');
        var input = $("#" + $(label).attr("for"));
        label.addClass('topTitleComponent-shopByLink');
        label.attr("data-at-for", input.data("at"));
        label.click(topTitleMenu.toggleSelected);
        labels.push(label);
      }
    }

    //hides the old application filter selection
    $(filterComponent).parent().addClass('hidden');
    $(labelDestination).html(labels);
    if (topTitleMenu.hasPreselectedApplicationType()) {
      showAllOption.removeClass("active");
      topTitleMenu.setApplicationType();
    }
    showAllOption.click(topTitleMenu.showAll);
    $(labelDestination).prepend(showAllOption);
  },
  hasPreselectedApplicationType: function hasPreselectedApplicationType() {
    var applicationTypeIndex = window.location.search.replace("?", "").indexOf("at=");
    if (applicationTypeIndex > -1) {
      return true;
    }
    return false;
  },
  setApplicationType: function setApplicationType() {
    var applicationTypeIndex = window.location.search.replace("?", "").indexOf("at=");
    if (applicationTypeIndex > -1) {
      var applicationType = getParameterByName("at");
      $(".topTitleComponent-shopByLink[data-at-for='" + applicationType + "'").click();
    }
  },
  toggleSelected: function toggleSelected(event) {
    event.preventDefault();
    var clickedApplication = $(event.target);
    var filterComponent = $('#filterComponent').find('[data-pimid="ModelApplication"]');
    var listOfSiblings = filterComponent.siblings('div');

    //Set correct input filed to checked
    for (var i = 0; i < listOfSiblings.length; i++) {
      var input = $(listOfSiblings[i]).find('input');
      if ($(input).attr('id') === clickedApplication.attr('for')) {
        $(input).prop('checked', true);
      } else {
        $(input).prop('checked', false);
      }
    }

    //remove styling
    var allSelections = $('#topTitleComponent').find('.topTitleComponent-shopByLink');
    for (var i = 0; i < allSelections.length; i++) {
      $(allSelections[i]).removeClass('active');
    }

    //Set to active
    clickedApplication.addClass('active');

    //Refreshes the filter form
    $('#filterComponent-options').change();
  },
  showAll: function showAll(event) {
    var clickedApplication = $(event.target);
    var filterComponent = $('#filterComponent').find('[data-pimid="ModelApplication"]');
    var listOfSiblings = filterComponent.siblings('div');

    //Set correct input filed to checked
    for (var i = 0; i < listOfSiblings.length; i++) {
      var input = $(listOfSiblings[i]).find('input');
      $(input).prop('checked', false);
    }
    var allSelections = $('#topTitleComponent').find('.topTitleComponent-shopByLink');
    for (var i = 0; i < allSelections.length; i++) {
      $(allSelections[i]).removeClass('active');
    }

    //Set to active
    clickedApplication.addClass('active');

    //Refreshes the filter form
    $('#filterComponent-options').change();
  }
};
$(document).ready(function () {
  topTitleMenu.init();
});